export default "__VITE_ASSET__9W4209Rw__"